import React from 'react';
export const ParaQuienEs: React.FC = () => {
  const items = [{
    emoji: '👧',
    text: 'Tu hijo ama colorear'
  }, {
    emoji: '🏰',
    text: 'Ama los personajes Disney'
  }, {
    emoji: '🎨',
    text: 'Quiere desarrollar su creatividad'
  }, {
    emoji: '📱',
    text: 'Buscas menos tiempo frente a pantallas'
  }, {
    emoji: '🖨️',
    text: 'Quieres imprimir cuando quieras'
  }, {
    emoji: '🎁',
    text: 'Buscas una actividad económica y divertida'
  }];
  return <section className="py-7 px-4 bg-cream" data-id="element-130">
      <div className="max-w-2xl mx-auto" data-id="element-131">
        <h2 className="font-rounded font-bold text-[2rem] sm:text-4xl text-violet text-center leading-tight mb-2" data-id="element-132">
          Una actividad mágica, creativa y{' '}
          <span className="text-gold-dark" data-id="element-133">sin pantallas</span>
        </h2>
        <p className="text-center text-textsoft mb-6 text-base font-semibold" data-id="element-134">
          Perfecta para entretener, compartir en familia y crear momentos
          inolvidables.
        </p>

        <div className="bg-white rounded-3xl border-t-[6px] border-gold p-5 sm:p-7 shadow-card" data-id="element-135">
          <p className="text-center font-rounded font-bold text-textsoft uppercase text-xs tracking-widest mb-4" data-id="element-136">
            Esta biblioteca es para ti si...
          </p>
          <ul className="space-y-3" data-id="element-137">
            {items.map((item, idx) => <li key={idx} className="flex items-start gap-3 pb-3 border-b-2 border-dashed border-cream-dark last:border-b-0 last:pb-0" data-id="element-138">
                <span className="text-2xl flex-shrink-0 leading-none" data-id="element-139">
                  {item.emoji}
                </span>
                <span className="text-violet font-bold text-base sm:text-lg leading-snug pt-0.5" data-id="element-140">
                  {item.text}
                </span>
              </li>)}
          </ul>
        </div>
      </div>
    </section>;
};